export const SAVE_TEXT = "Save";
export const EDIT_EMAIL_TEXT = "Edit email";
export const CANCEL_TEXT = "Cancel";
